import {
  listNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from '@/lib/api/notifications';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const KEYS = {
  all: ['notifications'] as const,
  list: () => [...KEYS.all, 'list'] as const,
};

/**
 * Lista notifications + count de não lidas. Polling 30s pra refresh sem
 * Socket.IO (fase futura troca por subscription real-time).
 *
 * `staleTime` 0 — queremos sempre re-fetch quando re-abrir dropdown
 * pra mostrar dado fresco. `refetchInterval` 30s mantém badge atualizado
 * em tempo real "barato".
 */
export function useNotifications() {
  return useQuery({
    queryKey: KEYS.list(),
    queryFn: ({ signal }) => listNotifications({ limit: 50 }, signal),
    refetchInterval: 30_000,
    staleTime: 0,
  });
}

export function useMarkNotificationAsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markNotificationAsRead(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEYS.list() });
    },
  });
}

export function useMarkAllNotificationsAsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => markAllNotificationsAsRead(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEYS.list() });
    },
  });
}

export const notificationKeys = KEYS;
